import CategoryLeaders from './components/CategoryLeaders'
import Default from './components/Default'
import RatingStars from './components/RatingStars'

const Facet = {
  CategoryLeaders,
  Default,
  RatingStars,
}

export default Facet
